import { Image, ImagePosition } from "@custom/schema";
import clsx from "clsx";
import React from "react";
import { MarkupText } from "./MarkupText";
//only used as a nested paragraph (e.g a child of ParagraphAccordion), otherwise should use ParagraphTwoColumnsImageTextWithBackground
export function ParagraphTwoColumnsImageText(props) {
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx("paragraph-container container-page", {
            "pb-0": props.isNested
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("flex flex-col lg:flex-row gap-[1.875rem] items-start lg:items-center", {
            "lg:flex-row-reverse": props.imagePosition === ImagePosition.Right
        })
    }, props.title && !props.hideTitle && /*#__PURE__*/ React.createElement(React.Fragment, null, !props.isNested ? /*#__PURE__*/ React.createElement("h2", {
        className: "block lg:hidden m-0"
    }, props.title) : /*#__PURE__*/ React.createElement("h3", {
        className: "block lg:hidden m-0"
    }, props.title)), !!props.imageSource && /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/2 self-start"
    }, /*#__PURE__*/ React.createElement(Image, {
        className: "object-cover w-full",
        source: props.imageSource,
        alt: props.imageAlt || ""
    })), /*#__PURE__*/ React.createElement("div", {
        className: "lg:w-1/2 gap-[1.875rem] flex flex-col"
    }, props.title && /*#__PURE__*/ React.createElement(React.Fragment, null, !props.isNested ? /*#__PURE__*/ React.createElement("h2", {
        className: "hidden lg:block m-0"
    }, props.title) : /*#__PURE__*/ React.createElement("h3", {
        className: "hidden lg:block m-0"
    }, props.title)), /*#__PURE__*/ React.createElement("div", null, props.text && /*#__PURE__*/ React.createElement(MarkupText, {
        markup: props.text
    })))));
}
